import { createSlice } from "@reduxjs/toolkit";

export const formSlice = createSlice({
  name: "form",
  initialState: {
    formType: "", // 表單類型
    formStep: "", // step
    formUser: null, // 個人資料
    formDetail: {}, // 內容
  },
  reducers: {
    setFormType: (state, action) => {
      localStorage.setItem("formType", String(action.payload));
      state.formType = action.payload;
    },
    setFormStep: (state, action) => {
      localStorage.setItem("formStep", String(action.payload));
      state.formStep = action.payload;
    },
    setFormUser: (state, action) => {
      localStorage.setItem("formUser", JSON.stringify(action.payload));
      state.formUser = action.payload;
    },
    setFormDetail: (state, action) => {
      localStorage.setItem("formDetail", JSON.stringify(action.payload));
      state.formDetail = action.payload;
    },
  },
});

export const { setFormType, setFormStep, setFormUser, setFormDetail } =
  formSlice.actions;

export default formSlice.reducer;
